import React, { useState, useEffect } from "react";
import {
  Button,
  Card,
  CardHeader,
  Table,
  Container,
  Row,
  Col,
  Form,
  FormGroup,
  InputGroupAddon,
  InputGroupText,
  Input,
  InputGroup,
  Media,
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Modal,
  ModalHeader,
  ModalBody,
  UncontrolledTooltip,
} from "reactstrap";
import { api } from '../../../../api';
import { CKEditor } from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import Header from "dashboard/hr-management/components/Headers/Header";
import Cookies from "js-cookie";

const Department3 = () => {
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [projectDropdownOpen, setProjectDropdownOpen] = useState(false);
  const [showDeleteConfirmation, setShowDeleteConfirmation] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const [filteredData, setFilteredData] = useState([]);
const [departdata, setdepartdata] = useState([]);

  // Move fetchData to top-level so it is in scope for all usages
  const fetchData = async () => {
    try {
      const company_id = Cookies.get('company_id');
      const response = await api.get(`department.php?company_id=${company_id}`);
      setdepartdata(response.data);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  useEffect(() => {
    // Fetch data and set departdata
  fetchData(); // Call the fetchData function
}, []); // Empty dependency array to run only once when component mounts

useEffect(() => {
  // Filter the data when searchQuery or departdata changes
  const originalData = departdata || [];
  const filtered = originalData.filter((item) =>
    item.dept_name.toLowerCase().includes(searchQuery.toLowerCase())
  );
  setFilteredData(filtered);
}, [searchQuery, departdata]); // Dependency array includes searchQuery and departdata

const [showAddDepartmentModal, setshowAddDepartmentModal] = useState(false);

  const toggleAddDepartmentModal = () => {
    setshowAddDepartmentModal(!showAddDepartmentModal);
  };

  const [department, setdepartment] = useState();
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setdepartment((prevState) => ({
      ...prevState,
      [name]: value,
    }));

    console.log(department)
  };
  const handleFileChange = (e) => {
    const file = e.target.files[0];
    setdepartment(prevState => ({
        ...prevState,
        dept_logo: file
    }));
    console.log(department)
};

    // Function to handle form submission
    const [showSuccessAlert, setShowSuccessAlert] = useState(false);
    const [successMessage, setSuccessMessage] = useState("");
    const handleSubmit = async (event) => {
      event.preventDefault();
      if (!department?.dept_name || !department?.dept_logo) {
        alert("Please fill in all required fields.");
        return;
      }
      const formDataToSend = new FormData();
      formDataToSend.append('dept_name', department.dept_name);
      formDataToSend.append('dept_logo', department.dept_logo);
      formDataToSend.append('company_id', Cookies.get('company_id'));
      try {
          const response = await api.post("department.php", formDataToSend);
        setSuccessMessage("Department added successfully!");
        setShowSuccessAlert(true);
        setTimeout(() => {
          setShowSuccessAlert(false);
          window.location.reload();
        }, 2000);
      } catch (error) {
          console.error("Error submitting data:", error);
          alert("Error submitting department. Please check your input and try again.");
      }
  };


  const [itemIdToDelete, setItemIdToDelete] = useState(null);

  const handleDeleteIconClick = (d_id) => {
    setItemIdToDelete(d_id);
    setShowDeleteConfirmation(true);
  };

  const handleDeleteConfirmation = (e) => {
    e.preventDefault();
    const d_id = itemIdToDelete;
    if(d_id !=null){
      const fetchData = async () => {
        try { 
          const response = await api.get(`department.php?d_id=${d_id}&company_id=${Cookies.get('company_id')}`);  
          setSuccessMessage("Department deleted successfully!");
          setShowSuccessAlert(true);
          setTimeout(() => {
            setShowSuccessAlert(false);
          window.location.reload();
          }, 2000);
        } catch (error) {  
          console.error("Error deleting department:", error); 
          alert("Error deleting department. Please try again.");
        }  
      };  
      fetchData();
    }
    setItemIdToDelete(null);
    setShowDeleteConfirmation(false);
  };

  return (
    <>
      <div className="header bg-gradient-info py-7 py-lg-8">
        <Container fluid>
           <Row className="mb-5 align-items-center">
  {/* Heading */}
  <Col xs="12" lg="4" className="text-center lg:text-start mb-3 mb-lg-0">
    <h1 className="text-black mb-0 font-bold">Departments List</h1>
  </Col>

  {/* Search and Button */}
  <Col xs="12" lg="8">
    <div className="d-flex flex-column flex-md-row justify-content-center justify-content-lg-end align-items-center gap-2 w-100">
      {/* Search Bar */}
      <Form
        className="navbar-search px-2 w-100"
        style={{ maxWidth: '300px' }}
      >
        <FormGroup className="mb-0 w-100">
          <InputGroup className="input-group-alternative align-items-center h-[40px]">
            <InputGroupAddon addonType="prepend">
              <InputGroupText className="border-right-0 h-[38px]">
                <i className="fas fa-search text-black px-2" />
                <Input
                  placeholder="Search Department"
                  type="text"
                  className="border-left-0 ml-2 h-[38px]"
                  value={searchQuery}
                  onChange={(e) => setSearchQuery(e.target.value)}
                />
              </InputGroupText>
            </InputGroupAddon>
          </InputGroup>
        </FormGroup>
      </Form>

      {/* Add Button */}
      <Button
        className="px-3 py-2"
        onClick={toggleAddDepartmentModal}
        style={{
          backgroundColor: '#d86f89',
          borderColor: '#d86f89',
          color: 'black',
        }}
      >
        ADD
      </Button>
    </div>
  </Col>
</Row>

          <Row className="mt-5">
            <Col className="mb-5 mb-xl-0" xl="12">
              <Card className="" style={{boxShadow: '0 4px 8px rgba(0, 0, 0, 0.15)',backgroundColor: '#fff',borderRadius: '15px'}}>
                <Table className="align-items-center table-flush" responsive>
                  <thead className="thead-light">
                    <tr style={{ textAlign: "center" }}>
                      <th style={{ fontSize: "14px", color: "black", fontWeight: "700" }} scope="col">S.No</th>
                      <th style={{ fontSize: "14px", color: "black", fontWeight: "700" }} scope="col">Department Logo</th>
                      <th style={{ fontSize: "14px", color: "black", fontWeight: "700" }} scope="col">Department Name</th>
                      <th style={{ fontSize: "14px", color: "black", fontWeight: "700" }} scope="col">Action</th>
                    </tr>
                  </thead>
                  <tbody style={{ textAlign: "center" }}>
                    {filteredData && filteredData.length > 0 && filteredData.map((item, index) => (
                      <tr key={index}>
                        <th scope="row">{++index}</th>
                        <td style={{textAlign:'center'}}>
                          <a
                            className="avatar rounded-circle m-2"
                              href="#pablo"
                            onClick={e => e.preventDefault()}
                            >
                          <img
                            alt="..."
                            src={item.dept_logo ? 
                                (window.location.hostname === 'localhost'
                                  ? `${window.location.protocol}//${window.location.hostname}:3000/images/${item.dept_logo}`
                                  : `/images/${item.dept_logo}`)
                                : (window.location.hostname === 'localhost'
                                    ? `${window.location.protocol}//${window.location.hostname}:3000/images/default-profile.png`
                                    : '/images/default-profile.png')}
                              onError={e => { e.target.onerror = null; e.target.src = (window.location.hostname === 'localhost'
                                    ? `${window.location.protocol}//${window.location.hostname}:3000/images/default-profile.png`
                                    : '/images/default-profile.png'); }}
                              style={{width: '48px', height: '48px', objectFit: 'cover', borderRadius: '50%'}}
                          />
                          </a>
                          </td>
                        <td style={{verticalAlign:'middle', textAlign:'center'}}>
                          <h4 style={{margin:0}}>{item.dept_name}</h4>
                        </td>
                        <td>
                          <i
                            className="fa fa-trash"
                            id={`delete-tooltip-${item.d_id}`}
                            style={{ fontSize: "23px", color: "red", cursor: "pointer" }}
                            onClick={() => handleDeleteIconClick(item.d_id)}
                          ></i>
                          <UncontrolledTooltip delay={0} target={`delete-tooltip-${item.d_id}`}>
                            Delete Department
                          </UncontrolledTooltip>
                        </td>
                      </tr>
                    ))}   
                    {filteredData && filteredData.length === 0 && (
                      <tr>
                        <td colSpan="4" style={{ textAlign: "center" }}>
                          No department found
                        </td>
                      </tr>
                    )}
                  </tbody>
                </Table>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>

      <Modal
        isOpen={showDeleteConfirmation}
        toggle={() => setShowDeleteConfirmation(false)}
      >
        <ModalHeader>Confirm Deletion</ModalHeader>
        <ModalBody>Are you sure you want to delete this department ?</ModalBody>
        <div className="modal-footer">
          <Button color="danger" onClick={handleDeleteConfirmation}>
            Yes
          </Button>
          <Button
            color="secondary"
            onClick={() => setShowDeleteConfirmation(false)}
          >
            No
          </Button>
        </div>
      </Modal>

      <Modal isOpen={showAddDepartmentModal} toggle={toggleAddDepartmentModal}>
        <ModalHeader toggle={toggleAddDepartmentModal}><h2 style={{fontWeight:'bolder', textTransform:'uppercase'}}>New Department</h2></ModalHeader>
        <ModalBody>
          <Form onSubmit={handleSubmit} enctype="multipart/form-data" >
            <Row>
              <Col md={12}>
                <FormGroup>
                  <label className="form-control-label" htmlFor="input-name">
                    Department Name *
                  </label>
                  <Input
                    className="form-control-alternative"
                    id="input-name"
                    type="text"
                    name="dept_name"
                    pattern="^[a-zA-Z ]+$"
                    title="Enter letters only"
                    placeholder="Enter Department Name" 
                    onChange={handleInputChange}
                    required
                  />
                </FormGroup>
              </Col>
              
              <Col md={12}>
                <FormGroup>
                  <label className="form-control-label" htmlFor="input-file">
                    Upload Department Logo *
                  </label>
                  <Input
                    type="file"
                    className="form-control"
                    id="input-file" accept="image/*"
                    name="dept_logo" 
                    onChange={handleFileChange}
                    required
                  />
                </FormGroup>
              </Col>
            </Row>
            <Row>
              <Col lg="12" style={{ textAlign: "center" }}>
                <Button style={{backgroundColor: '#E08681', borderColor: '#E08681', color: 'black'}} type="submit">
                  Submit
                </Button>
              </Col>
            </Row>
          </Form>
        </ModalBody>
      </Modal>

      {showSuccessAlert && (
        <div style={{
          position: 'fixed', top: 0, left: 0, right: 0, bottom: 0,
          backgroundColor: 'rgba(0,0,0,0.5)', display: 'flex',
          justifyContent: 'center', alignItems: 'flex-start', paddingTop: '15%', zIndex: 9999
        }}>
          <div style={{
            backgroundColor: '#fff', padding: '30px', borderRadius: '15px',
            boxShadow: '0 10px 30px rgba(0,0,0,0.3)', textAlign: 'center',
            maxWidth: '400px', width: '90%', border: '3px solid #d86f89'
          }}>
            <div style={{ fontSize: '48px', color: '#d86f89', marginBottom: '20px' }}>✓</div>
            <h4 style={{ color: '#28a745', marginBottom: '15px' }}>Success!</h4>
            <p style={{ color: '#333', fontSize: '16px', marginBottom: '20px' }}>{successMessage}</p>
          </div>
        </div>
      )}
    </>
  );
};

export default Department3;
